import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IJournalPaymentType } from "src/models/Accounting/Accounting.models";

interface JournalPaymentTypeState {
  journalPaymentTypes: IJournalPaymentType[];
  journalPaymentTypeToEdit: IJournalPaymentType | null;
}

const initialState: JournalPaymentTypeState = {
  journalPaymentTypes: [],
  journalPaymentTypeToEdit: null,
};

const JournalPaymentTypeSlice = createSlice({
  name: "JournalPaymentType",
  initialState,
  reducers: {
    setJournalPaymentTypeList: (
      state,
      action: PayloadAction<IJournalPaymentType[]>
    ) => {
      state.journalPaymentTypes = action.payload;
    },
    setJournalPaymentTypeToEdit: (
      state,
      action: PayloadAction<IJournalPaymentType | null>
    ) => {
      state.journalPaymentTypeToEdit = action.payload;
    },
    addJournalPaymentType: (
      state,
      action: PayloadAction<IJournalPaymentType>
    ) => {
      state.journalPaymentTypes.push(action.payload);
    },
    updateJournalPaymentType: (
      state,
      action: PayloadAction<IJournalPaymentType>
    ) => {
      let itemIndex = state.journalPaymentTypes.findIndex(
        item =>
          item.journalPaymentTypeId ===
          action.payload.journalPaymentTypeId
      );
      if (itemIndex !== -1)
        state.journalPaymentTypes[itemIndex] = action.payload;
    },
    deleteJournalPaymentType: (state, action: PayloadAction<number>) => {
      const newArray = state.journalPaymentTypes.filter(
        item => item.journalPaymentTypeId !== action.payload
      );
      state.journalPaymentTypes = newArray;
    },
  },
});

export const {
  setJournalPaymentTypeList,
  setJournalPaymentTypeToEdit,
  addJournalPaymentType,
  updateJournalPaymentType,
  deleteJournalPaymentType,
} = JournalPaymentTypeSlice.actions;

export default JournalPaymentTypeSlice.reducer;
